<div class="db-notification-dialog">
  <div class="db-content-wrap">
    <div class="db-content">
      <div class="db-notification-dialog__animation">
        <ng-lottie
          [options]="lottieConfig"
          style="width: 101px; height: 101px; display: block"
        ></ng-lottie>
      </div>

      <div class="db-notification-dialog__header" [innerHTML]="header"></div>
      <div class="db-notification-dialog__message">
        <p [innerHTML]="message"></p>
      </div>
    </div>

    <div class="db-notification-dialog__buttons-wrap">
      <a class="ds-btn-ls ds-btn-black" (click)="close()"><span>{{ buttonText | lowerCaseSpecificWords }}</span></a>
    </div>
  </div>
</div>


